export default "__VITE_ASSET__DqjnXSFF__"